import React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { Card, Typography, Theme } from "@material-ui/core";
import { Icon } from "../icons/Icon";
import { Button } from "../inputs/Button";
import classNames from "../../utils/classNames";

export type DetailCardProps = {
  className?: string;
  id: string;
  listItems?: {
    icon: string;
    label: string;
  }[];
  onView: () => void;
  title: string;
  btnDisabled?: boolean;
};

type State = {};

const styles = (theme: Theme) =>
  createStyles({
    buttonWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%"
    },
    contentContainer: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between"
    },
    itemIcon: {
      color: theme.palette.primary.light,
      marginRight: theme.spacing(1)
    },
    listItem: {
      display: "flex",
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(1)
    },
    root: {
      height: "fit-content",
      maxWidth: "360px",
      margin: theme.spacing(2),
      overflow: "unset",
      padding: theme.spacing(2),
      width: "100%"
    },
    title: {
      marginBottom: theme.spacing(2)
    }
  });

class DetailCard extends React.Component<WithStyles & DetailCardProps, State> {
  render() {
    const {
      className,
      classes,
      listItems,
      onView,
      title,
      btnDisabled
    } = this.props;
    return (
      <Card className={classNames(className, classes.root)}>
        <Typography className={classes.title} variant="subtitle1">
          {title}
        </Typography>
        <div className={classes.contentContainer}>
          {!btnDisabled &&
            listItems &&
            listItems.map(({ icon, label }) => (
              <div className={classes.listItem} key={label}>
                <Icon className={classes.itemIcon} name={icon} />
                <Typography>{label}</Typography>
              </div>
            ))}
          <div className={classes.buttonWrapper}>
            <Button
              id="view"
              disabled={btnDisabled}
              color="primary"
              onClick={onView}
              type="submit"
            >
              View
            </Button>
          </div>
        </div>
      </Card>
    );
  }
}

export default withStyles(styles)(DetailCard);
